export const HOME = "/";
export const ABOUT = "/about";
export const CONTACT_US = "/contact";
export const CAREERS = "/careers";
export const EXAMPLE = "/example";
export const PROJECTS = "/projects";
export const SELECTED_PROJECT = "/projects/:projectId";
export const NOT_FOUND = "*";
